import { Pipe, PipeTransform } from '@angular/core';
import { RechtsgrundEntryMeta } from '../../../core/gb-api';
import { environment } from '../../../../environments/environment';

@Pipe({
  name: 'uniqueErwerbsgrundPipe'
})
export class UniqueErwerbsgrundPipe implements PipeTransform {
  transform(rechtsgruende: Array<RechtsgrundEntryMeta>): Array<RechtsgrundEntryMeta> {
    if (environment.deploymentMode !== 'PUBLIC' || rechtsgruende.length <= 1) {
      return rechtsgruende;
    } else {
      const unique_rechtsgruende = new Array<RechtsgrundEntryMeta>();
      const dates = new Array<String>();
      rechtsgruende.forEach((value) => {
        if (!dates.includes(value.beleg.datum)) {
          dates.push(value.beleg.datum);
          unique_rechtsgruende.push(value);
        }
      });
      return unique_rechtsgruende;
    }
  }
}
